export const Endpoint = () => `/api/v3/admin/modifyUserCredit`;
export const Csrf = () => `/api/v3/admin/token/`;

export interface Payload {
    userid: string;
    amount: number;
    unlimited_until: string;
}

export type Response = void;
